import { PalmettoIcon } from '@palmetto/dsm-components';

interface FlagAlertBadgeProps {
  verdict: 'pass' | 'fail' | 'incomplete';
  message: string;
}

export const FlagAlertBadge = ({ verdict, message }: FlagAlertBadgeProps) => {
  const styles = {
    pass: {
      icon: 'check',
      className: 'bg-banner-canvas-success-default text-banner-text-primary-success-default',
    },
    fail: {
      icon: 'flagFilled',
      className: 'bg-banner-canvas-error-default text-banner-text-primary-error-default',
    },
    incomplete: {
      icon: 'minus',
      className: 'bg-canvas-subtle text-text-secondary',
    },
  } as const;

  const { icon, className: verdictClassName } = styles[verdict];

  return (
    <span className={`body-sm inline-flex items-center gap-6 rounded-8 px-10 py-6 font-medium ${verdictClassName}`}>
      <PalmettoIcon name={icon} size="sm" />
      {message}
    </span>
  );
};
